import { useState } from 'react';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/flipad-logo-white.svg';

// The footer is near-identical across every page, but three links genuinely
// point somewhere different depending on which page renders it (verified
// against the source: each one is a deliberate same-page anchor on the pages
// that have that section, falling back to a cross-page link elsewhere). These
// props default to index/blog/blog-article's own values so most callers don't
// need to pass anything.
export default function Footer({
  discoverSpacesHref = '/advertisers',
  discoverSpacesLabel = 'Discover spaces',
  listASpaceHref = '/space-owners',
  escrowHref = '/#escrow',
}) {
  const [copied, setCopied] = useState(false);
  const isDiscoverSpacesPlaceholder = discoverSpacesHref === '#';

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('support@flipad.in').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container">
        <div className="footer-top">
          <div>
            <img className="footer-logo" src={logoWhite} alt="FlipAd" />
            <p className="footer-tagline">
              India&apos;s out-of-home advertising marketplace — connecting advertisers
              with space owners through a transparent, escrow-protected platform.
            </p>
          </div>
          <div>
            <p className="footer-col-title">Platform</p>
            <nav className="footer-links" aria-label="Platform links">
              {isDiscoverSpacesPlaceholder ? (
                <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>{discoverSpacesLabel}</a>
              ) : (
                <Link to={discoverSpacesHref} className="footer-link">{discoverSpacesLabel}</Link>
              )}
              {listASpaceHref === '#' ? (
                <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>List a space</a>
              ) : (
                <Link to={listASpaceHref} className="footer-link">List a space</Link>
              )}
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Pricing</a>
            </nav>
          </div>
          <div>
            <p className="footer-col-title">Company</p>
            <nav className="footer-links" aria-label="Company links">
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>About</a>
              <Link to="/blog" className="footer-link">Insights</Link>
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Careers</a>
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Contact</a>
            </nav>
          </div>
          <div>
            <p className="footer-col-title">Trust &amp; Safety</p>
            <nav className="footer-links" aria-label="Trust and safety links">
              {escrowHref === '#' ? (
                <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>How escrow works</a>
              ) : (
                <Link to={escrowHref} className="footer-link">How escrow works</Link>
              )}
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Verification policy</a>
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Dispute resolution</a>
              <a href="#" className="footer-link" onClick={(e) => e.preventDefault()}>Help centre</a>
            </nav>
          </div>
        </div>

        <div className="footer-contact">
          <span className="footer-contact-text">For enquiries and questions, email</span>
          <span className="footer-contact-email">
            <a href="mailto:support@flipad.in" className="footer-contact-link">support@flipad.in</a>
            <button
              className={`footer-contact-copy${copied ? ' copied' : ''}`}
              id="copy-email-btn"
              aria-label="Copy email address"
              title="Copy email address"
              onClick={handleCopyEmail}
            >
              <i className={copied ? 'ph ph-check' : 'ph ph-copy'} aria-hidden="true" />
            </button>
          </span>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">&copy; 2026 FlipAd Technologies Pvt. Ltd. All rights reserved.</p>
          <nav className="footer-legal" aria-label="Legal links">
            <a href="#" onClick={(e) => e.preventDefault()}>Privacy Policy</a>
            <a href="#" onClick={(e) => e.preventDefault()}>Terms of Use</a>
            <a href="#" onClick={(e) => e.preventDefault()}>Cookie Policy</a>
          </nav>
          <div className="footer-social" aria-label="Social links">
            <a href="#" className="footer-social-link" aria-label="LinkedIn" onClick={(e) => e.preventDefault()}><i className="ph ph-linkedin-logo" aria-hidden="true" /></a>
            <a href="#" className="footer-social-link" aria-label="Twitter / X" onClick={(e) => e.preventDefault()}><i className="ph ph-x-logo" aria-hidden="true" /></a>
            <a href="#" className="footer-social-link" aria-label="Instagram" onClick={(e) => e.preventDefault()}><i className="ph ph-instagram-logo" aria-hidden="true" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
